import { BackendSocket } from '../../hooks/use-socket';
import { BackendPayload } from './payloads';
import { closeModal } from '../../stores/backend';
import { meta } from '../../stores/backend';

export const onConnect = (
    socket: BackendSocket,
    { payload }: { payload: BackendPayload }
) => {
    const callback = async () => {
        // Default to false (manual reload required) unless explicitly set to 'true'
        const autoReconnect =
            import.meta.env.REACT_APP_WS_AUTO_RECONNECT === 'true';

        await payload.loadGame();
        await payload.loadGame(true);

        // If auto-reconnect is enabled, close the modal after successful reconnection
        if (autoReconnect) {
            if (meta.modals.msgCommon.isOpen.value) {
                closeModal('msgCommon');
            }
        }
        // Otherwise, user must manually reload via the button shown in the modal
    };

    socket.on('connect', callback);

    return () => {
        socket.off('connect', callback);
    };
};
